import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { IDateProps } from './IDateProps'
import { IEntity } from "../../../../../base/types"
import { InputFieldHelper } from '../InputHelper'
import clsx from 'clsx'
import { useDateValidationSchema } from './DateValidationSchema'
import { useFormContext } from '../../form'
import { useFormikContext } from "formik"

interface IDateFieldProps extends HTMLAttributes<HTMLInputElement>, IDateProps {
    name: string
}

export const DateField: FC<IDateFieldProps> = (props) => {
    const { id, name, placeholder, className, title, readOnly, disabled } = props
    const shape = useDateValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    fieldProps = { ...fieldProps, value: InputFieldHelper.toDate(fieldProps.value ?? '') };

    return <>
        <input
            type='date'
            id={id}
            {...fieldProps}
            className={clsx(className, "form-control form-control-sm")}
            title={title}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
